import {
  FaLinkedinIn,
  FaTwitter,
  FaInstagram,
  FaTelegramPlane,
  FaFacebook,
} from "react-icons/fa";

const data = [
  {
    icon: <FaLinkedinIn />,
    url: "#",
  },
  {
    icon: <FaInstagram />,
    url: "#",
  },
  {
    icon: <FaTwitter />,
    url: "#",
  },
  {
    icon: <FaTelegramPlane />,
    url: "#",
  },
  {
    icon: <FaFacebook />,
    url: "#",
  },
];

export default data;
